import React from "react";
import { Zap } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Canonical AutoAds logo. Click destination follows a single rule:
 *   • authed user → /dashboard
 *   • guest       → /
 * Pass `to="/dashboard"` or `to="/"` to override.
 */
export default function Logo({ to, size = "md", className = "", testid = "app-logo" }) {
    const { user } = useAuth();
    const target = to || (user ? "/dashboard" : "/");
    const isLg = size === "lg";
    return (
        <a
            href={target}
            data-testid={testid}
            className={`flex items-center gap-2 font-display font-bold text-text-primary hover:opacity-80 transition ${isLg ? "text-xl" : "text-lg"} ${className}`}
        >
            <Zap size={isLg ? 22 : 18} className="text-primary-c" fill="#6D5EF8" />
            <span>AutoAds</span>
        </a>
    );
}
